<ws-modal-wrapper headerLabel="My Tasks Settings"
                  acceptLabel="Save"
                  cancelLabel="Close"
                  [loading]="loading"
                  [excludeModalStyling]="true"
                  (save)="saveAndClose()"
                  (cancel)="bsModalRef.hide()">
    @if (!loading) {
        <div class="mb-4">
            <label>Show</label>
            <select [(ngModel)]="selectedMyTasksView">
                @for (item of myTasksViews; track item) {
                    <option [ngValue]="item.viewId">{{ item.name }}</option>
                }
            </select>
        </div>
    }
</ws-modal-wrapper>
